
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#4189DD","d":"M0 0h27v18H0V0z"}}),_c('path',{attrs:{"fill":"#F9D616","d":"M0 12h27v1H0v1h27v1H0v-3z"}}),_c('path',{attrs:{"fill":"#D21034","stroke":"#FFF","stroke-width":".2","stroke-miterlimit":"10","d":"M4.625 3.375L4 1.35l-.625 2.025L1.35 4l2.025.625L4 6.65l.625-2.025L6.65 4z"}})])
          )
        }
      }
    